export default __webpack_public_path__ + "static/media/score-board-233x88.386a2062.svg";